import React, { useContext } from 'react';
import { observer } from 'mobx-react';

import { AuthContext } from 'core/components/auth';
import { FormField } from 'core/components/form';
import { isCanonicalUser } from 'core/helpers/troubleshooting-mode';
import { useStore } from 'core/store/store.mobx';

import useStyles from '../footer.styles';

// Shown to troubleshooters only once the flag is explicitly set (true OR false) — the `!= null`
// gate keeps the toggle on a published (off) offer instead of silently re-flagging it on the next
// update. Hidden for canonical users and never-flagged offers (first edit auto-flags those).
const TroubleshootingToggle = observer(() => {
  const { offer: store } = useStore();
  const classes = useStyles();
  const session = useContext(AuthContext);

  const troubleshootingMode = store.offer?.quote?.global?.troubleshootingMode;
  if (isCanonicalUser(session) || troubleshootingMode == null) {
    return null;
  }

  return (
    <div className={classes.troubleshootingToggle}>
      <FormField
        mode="light"
        name="troubleshootingMode"
        label="Troubleshooting mode"
        type="checkbox"
        tooltipText="Hides your changes from external agents while you troubleshoot. Uncheck only when your changes are ready for the agent to use."
        tooltipLabel="More Info"
        labelClassName={classes.troubleshootingLabel}
      />
    </div>
  );
});

export default TroubleshootingToggle;
